
import { useState, useEffect } from "react";
import { useUserStorage } from "@/hooks/campaign/utils/storageUtils";

export const useCampaignName = () => {
  const { getItem, setItem } = useUserStorage();
  const [campaignName, setCampaignName] = useState<string>(() => {
    // Try to get from user-specific localStorage first
    const userSpecificName = getItem('campaignName');
    
    // If not found, fallback to regular localStorage (for backward compatibility)
    const regularName = localStorage.getItem('campaignName');
    
    // Return empty string as default, not any fallback name
    return userSpecificName || regularName || "";
  });

  // Save campaign name to both storages when it changes
  useEffect(() => {
    if (campaignName !== undefined) {
      // Save to user-specific storage
      setItem('campaignName', campaignName);
      
      // Also save to regular localStorage for backward compatibility
      localStorage.setItem('campaignName', campaignName);
      
      console.log('Campaign name saved to both storages:', campaignName);
      
      // Trigger a draft save whenever the campaign name changes
      const triggerAutoSave = async () => {
        // We use this approach to avoid circular dependencies
        try {
          // Use a DOM event to trigger auto-save across components
          const event = new CustomEvent('campaign-name-changed', { 
            detail: { name: campaignName } 
          });
          window.dispatchEvent(event);
        } catch (error) {
          console.error("Error triggering auto-save after name change:", error);
        }
      };
      
      triggerAutoSave();
    }
  }, [campaignName, setItem]);

  return { campaignName, setCampaignName };
};
